import React, {useState} from 'react';
import {useMediaQuery} from "react-responsive";
import TopBar from "../TopBar";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {DEFAULT_GRADIENT, DEFAULT_THEME_COLOR} from "../../constants/theme";
import useTranslation from "../../customHooks/translations";
import ListHubsComponent from "./ListHubsComponent";
import {
  ALGOLIA_INDEX_NAME_FREAK_HUBS,
  FREAK_HUB_TYPE_EXPLORE,
  FREAK_HUB_TYPE_MY
} from "../../constants/commonConstants";
import SearchComponent from "../Search/SearchComponent";

const FreakHubView = (props) => {
  const translation = useTranslation();
  const context = props.context;
  const isDesktop = useMediaQuery({ minWidth: 992 });
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <TopBar />
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(180deg, #0d1b2a 0%, #091420 100%)',
          pt: 1,
          pb: 10,
        }}
      >
        <Box
          sx={{
            maxWidth: isDesktop ? 560 : '100%',
            mx: 'auto',
            px: { xs: 1, sm: 2 },
          }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label="freak-hub-tabs"
            sx={{
              mb: 1,
              '& .MuiTabs-indicator': {
                background: DEFAULT_GRADIENT,
                height: 3,
                borderRadius: 2,
              },
              '& .MuiTab-root': {
                color: 'rgba(255,255,255,0.45)',
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '0.95rem',
                '&:focus': { outline: 'none' },
              },
              '& .MuiTab-root.Mui-selected': {
                color: DEFAULT_THEME_COLOR,
                outline: 'none',
              },
            }}
          >
            <Tab label={translation.tabs.myHubs} />
            <Tab label={translation.tabs.exploreHubs} />
          </Tabs>

          <SearchComponent indexName={ALGOLIA_INDEX_NAME_FREAK_HUBS} context={context}/>

          {selectedTab === 0 && <ListHubsComponent type={FREAK_HUB_TYPE_MY}/>}
          {selectedTab === 1 && <ListHubsComponent type={FREAK_HUB_TYPE_EXPLORE}/>}
        </Box>
      </Box>
    </>
  );
};

export default FreakHubView;
